// @ts-strict-ignore
import React, { type ComponentPropsWithoutRef } from 'react';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { SvgArrowThinRight } from '../../icons/v1';
import { SvgRolloverIcon } from '../../icons/v2/RolloverIcon';
import { type CSSProperties } from '../../style';
import { View } from '../common/View';
import { type Binding } from '../spreadsheet';
import { CellValue } from '../spreadsheet/CellValue';
import { useSheetValue } from '../spreadsheet/useSheetValue';

import { makeBalanceAmountStyle } from './util';

type BalanceWithCarryoverProps = Omit<
  ComponentPropsWithoutRef<typeof CellValue>,
  'binding'
> & {
  carryover: Binding;
  balance: Binding;
  goal?: Binding;
  budgeted?: Binding;
  disabled?: boolean;
  carryoverStyle?: CSSProperties;
};
export function BalanceWithCarryover({
  carryover,
  balance,
  goal,
  budgeted,
  disabled,
  carryoverStyle,
  ...props
}: BalanceWithCarryoverProps) {
  const carryoverValue = useSheetValue(carryover);
  const balanceValue = useSheetValue(balance);
  const goalValue = useSheetValue(goal);
  const budgetedValue = useSheetValue(budgeted);
  const isGoalTemplatesEnabled = useFeatureFlag('goalTemplatesEnabled');
  const amountStyle = makeBalanceAmountStyle(
    balanceValue,
    goalValue,
    budgetedValue,
  );
  return (
    <>
      <CellValue
        {...props}
        binding={balance}
        type="financial"
        getStyle={value =>
          makeBalanceAmountStyle(
            value,
            isGoalTemplatesEnabled ? goalValue : null,
            budgetedValue,
          )
        }
        style={{
          textAlign: 'right',
          ...(!disabled && {
            cursor: 'pointer',
          }),
          ...props.style,
        }}
      />
      <View
        style={{
          alignSelf: 'center',
          marginLeft: 2,
          position: 'absolute',
          right: carryoverValue ? -8 : -10,
          top: 0,
          bottom: 0,
          justifyContent: 'center',
          cursor: 'pointer',
          ...carryoverStyle,
        }}
      >
        {carryoverValue ? (
          <SvgArrowThinRight
            width={carryoverStyle?.width || 7}
            height={carryoverStyle?.height || 7}
            style={amountStyle}
          />
        ) : (
          <SvgRolloverIcon
            width={12}
            height={12}
            style={{ ...amountStyle, cursor: 'pointer' }}
          />
        )}
      </View>
    </>
  );
}
